import { render, staticRenderFns } from "./StichtingSwitcher.vue?vue&type=template&id=1ff6c865&"
import script from "./StichtingSwitcher.vue?vue&type=script&lang=js&"
export * from "./StichtingSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports